/* eslint-disable react/prop-types */
import React from "react";
import { useSelector } from 'react-redux';

const Permissions = ({ tableData, premissionV, inputChange }) => {
  const isChecked = (value) => premissionV.includes(value);
  const l = useSelector((state) => state.language || "en");
  const t = useSelector((state) => state.translation || "en");
  //
  
  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    inputChange({value,checked})
  };
  //
  return (
    <div className="table-responsive">
      <table className="table  datanew">
        <thead>
          <tr>
            <th>{t[l]?.["modules"] || "Modules"}</th>
            <th>{t[l]?.["create"] || "Create"}</th>
            <th>{t[l]?.["view"] || "View"}</th>
            <th>{t[l]?.["update"] || "Update"}</th>
            <th>{t[l]?.["delete"] || "Delete"}</th>
        
          </tr>
        </thead>
        <tbody>
          {tableData?.map((item, key) => {
            return (
              <tr key={key}>
                <td>{item.pagename}</td>
                <td>
                  {/* create */}
                  {item.Create && (
                    <label className="checkboxs">
                      <input
                        type="checkbox"
                        value={item.Create}
                        checked={isChecked(item.Create)}
                        onChange={handleCheckboxChange}
                      />
                      <span className="checkmarks" />
                    </label>
                  )}
                </td>
                <td>
                  {/* view */}
                  {item.View && (
                    <label className="checkboxs">
                      <input
                        type="checkbox"
                        value={item.View}
                        checked={isChecked(item.View)}
                        onChange={handleCheckboxChange}
                      />
                      <span className="checkmarks" />
                    </label>
                  )}
                </td>
                <td>
                  {/* update */}
                  {item.Update && (
                    <label className="checkboxs">
                      <input
                        type="checkbox"
                        value={item.Update}
                        checked={isChecked(item.Update)}
                        onChange={handleCheckboxChange}
                      />
                      <span className="checkmarks" />
                    </label>
                  )}
                </td>
                <td>
                  {/* delete  */}
                  {item.Delete && (
                    <label className="checkboxs">
                      <input
                        type="checkbox"
                        value={item.Delete}
                        checked={isChecked(item.Delete)}
                        onChange={handleCheckboxChange}
                      />
                      <span className="checkmarks" />
                    </label>
                  )}
                </td>
            
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default Permissions;